<template>
    <MainContent title="DEPORTISTAS" format="plain">
        <template v-slot:header>
            <div class="text-right">
                <Button @click="showModal('descargar-informe')" icon="fa fa-download">Descargar informe</Button>
                <DescargarInforme :ruta="'back.bases.informe'" :url="url_descarga_informe" v-on:close="closeModal" name="descargar-informe" :detalle="true" :lista_id="lista_id"/>
                <router-link :to="{ name: 'back.bases.informe.categorias', params: { lista_id: lista_id } }" class="btn btn-primary ml-3">
                    <i class="fa fa-list-alt mr-2"></i>Categorías
                </router-link>
                <router-link :to="{ name: 'back.bases.informe.plazos-impagados', params: { lista_id: lista_id } }" class="btn btn-primary ml-3">
                    <i class="fa fa-euro-sign mr-2"></i>Estado de plazos
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <b-row v-if="!loading">
                <b-col cols="12" md="4">
                    <TotalRecaudacionComponent :totales="totales" :tipo="'DEPORTISTAS'" @buscar="getInforme"/>
                </b-col>
                <b-col cols="12" md="4">
                    <RenovacionesComponent :valores="valores_renovaciones" id="renovaciones"/>
                </b-col>
                <b-col cols="12" md="4">
                    <VentaDiariaComponent :valores="valores_venta_diaria_grafica" id="venta-diaria"/>
                </b-col>
                <b-col cols="12">
                    <VentasComponent :informe="informe" :detalle="detalle" :totales="totales" titulo="Ventas" id="ventas"/>
                </b-col>
                <b-col cols="12">
                    <VentasComponent :informe="devoluciones" :detalle="devoluciones_detalle" :totales="totales_devoluciones" titulo="Devoluciones" id="ventas"/>
                </b-col>
                <b-col cols="12">
                    <ResumenPlazos :lista_id="lista_id" id="resumen-plazos"/>
                </b-col>
                <b-col cols="12">
                    <CalendarioCobrosComponent :lista_id="lista_id" id="calendario-cobros"/>
                </b-col>
                <b-col cols="12">
                    <DesgloseCategoriasComponent :valores="desglose"/>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import DescargarInforme from '@/components/backend/components/DescargarInforme';
    import MainContent from "@/components/backend/components/MainContent";

    import TotalRecaudacionComponent from '@/components/backend/estadisticas/common/TotalRecaudacionComponent';
    import VentaDiariaComponent from '@/components/backend/estadisticas/common/VentaDiariaComponent';
    import RenovacionesComponent from '@/components/backend/estadisticas/bases/RenovacionesComponent';
    import VentasComponent from '@/components/backend/estadisticas/bases/VentasComponent';
    import CalendarioCobrosComponent from '@/components/backend/estadisticas/bases/CalendarioCobrosComponent';
    import DesgloseCategoriasComponent from '@/components/backend/estadisticas/bases/DesgloseCategoriasComponent';
    import ResumenPlazos from '@/components/backend/estadisticas/bases/ResumenPlazos';

    export default {
        data() {
            return {
                lista_id: this.$route.params.lista_id,
                informe: null,
                detalle: null,
                plazos: null,
                total_bases: null,
                total_recaudacion: null,
                venta_diaria: null,
                valores_venta_diaria_grafica: null,
                valores_renovaciones: null,
                desglose: null,
                devoluciones: null,
                devoluciones_detalle: null,
                loading: false
            }
        },
        methods: {
            getInforme(fecha_inicio, fecha_fin, lista_id) {
                this.loading = true;
                this.lista_id = lista_id;

                const params = {
                    filters : {
                        fecha_inicio: fecha_inicio,
                        fecha_fin: fecha_fin,
                        lista_id: lista_id
                    },
                    lista_id: lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.informe'), params).then(res => {
                    this.informe = res.data.informe;
                    this.detalle = res.data.detalle;
                    this.plazos = res.data.plazos;
                    this.total_bases = res.data.total_bases;
                    this.total_recaudacion = res.data.total_recaudacion;
                    this.venta_diaria = res.data.venta_diaria;
                    this.valores_renovaciones = res.data.estado_renovaciones;
                    this.devoluciones = res.data.devoluciones;
                    this.devoluciones_detalle = res.data.devoluciones_detalle;
                    this.getVentaDiaria();
                    this.setDesglose();
                }).finally(() => this.loading = false);
            },
            getVentaDiaria() {
                var valores = [];

                valores.push(['Fecha', 'Ventas']);

                for(var i in this.venta_diaria) {
                    valores.push([this.venta_diaria[i].fecha, this.venta_diaria[i].total]);
                }

                this.valores_venta_diaria_grafica = valores;
            },
            setDesglose() {
                var desglose = [
                    [], []
                ];

                for (var i = 0; i < this.informe.length; i++) {
                    if(desglose[0].indexOf(this.informe[i].categoria) == -1) {
                        desglose[0].push(this.informe[i].categoria);

                        desglose[1].push(this.informe[i].total);
                    } else {
                        var index = desglose[0].indexOf(this.informe[i].categoria);

                        desglose[1][index] = desglose[1][index] + this.informe[i].total;
                    }
                }

                var array = [
                    ['Categoría', 'Vendidos']
                ];

                for (var x = 0; x < desglose[0].length; x++) {
                    array.push([
                        desglose[0][x],
                        desglose[1][x]
                    ]);
                }

                this.desglose = array;
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            totales() {
                var totales = {};

                totales.importe = this.total_recaudacion;
                totales.vendidas = this.total_bases;

                return totales;
            },
            totales_devoluciones() {
                var totales = {};

                totales.vendidas = 0;
                totales.importe = 0;

                for(var i in this.devoluciones) {
                    totales.vendidas += this.devoluciones[i].total;
                    totales.importe += this.devoluciones[i].importe * this.devoluciones[i].total;
                }

                return totales;
            },
            url_descarga_informe() {
                return this.config.API_BASE + '/bases/informe?api_key=' + localStorage.getItem('token');
            }
        },
        created() {
            this.getInforme(null, null, this.lista_id)
        },
        components: { 
            DescargarInforme, MainContent, TotalRecaudacionComponent, VentaDiariaComponent,
            RenovacionesComponent, VentasComponent, CalendarioCobrosComponent, DesgloseCategoriasComponent, ResumenPlazos
        }
    }
</script>